import camelcase from 'lodash.camelcase';
import SelectionGroup from '@/components/account/targetingInfo/SelectionGroup.vue';
import SubSection from '@/components/account/targetingInfo/SubSection.vue';
import { getLabelForSection, mapOptions, getOptions, getSectionId } from '@/services/targetingInfo';
import updateMixin from '@/components/account/targetingInfo/updateMixin';

function withoutHash(value) {
  return value.replace(/#/g, '');
}

function defaultMixinArgsFactory(section) {
  return [
    getSectionId(section),
    (name) => ({
      update: (e) => ({ [name]: e.target.value }),
      clear: (value) => ({ [name]: value }),
    }),
  ];
}

export default function createTargetingInfoSelectComponent(
  section,
  mixinArgsFactory = defaultMixinArgsFactory,
) {
  return {
    name: `${camelcase(section.displayName)}Picker`,
    props: {
      displayData: {
        type: Object,
        required: true,
      },
      controlProps: {
        type: Object,
        default: () => ({}),
      },
    },
    mixins: [updateMixin(...mixinArgsFactory(section))],
    methods: {
      translate(key) {
        return this.$t(`targeting.info.${withoutHash(key)}`);
      },
      generateClassFromValue(value) {
        return `gc-${withoutHash(value)}`;
      },
      getPickerElementClass(el) {
        return `picker ${this.generateClassFromValue(this.getEntityId(el))}-picker`;
      },
      getEntityId(entity) {
        return getSectionId(entity) || entity.value;
      },
      renderSubSections(h) {
        return this.subSectionOptions.map((subSection) =>
          h(SubSection, {
            class: this.getPickerElementClass(subSection),
            props: {
              name: `sub-${section.displayName}`,
              label: this.getLabel(subSection),
              options: getOptions(subSection),
              defaultValue: this.modelValue,
              ...this.controlProps,
            },
            on: {
              change: this.onValueChange,
            },
          }),
        );
      },
      getLabel(entity) {
        return entity.displayName || entity.label || this.translate(this.getEntityId(entity));
      },
      optionsMapper({ label, value, ...data }) {
        return {
          ...data,
          value,
          label: getLabelForSection(label) || this.translate(value),
          itemClass: this.generateClassFromValue(value),
        };
      },
    },
    computed: {
      options() {
        return mapOptions(this.displayData, this.optionsMapper);
      },
      sectionOptions() {
        return this.options.filter((option) => !getOptions(option));
      },
      subSectionOptions() {
        return this.options.filter((option) => getOptions(option));
      },
    },
    render(h) {
      return h(
        SelectionGroup,
        {
          class: this.getPickerElementClass(this.displayData),
          props: {
            name: section.displayName,
            label: this.getLabel(this.displayData),
            options: this.sectionOptions,
            defaultValue: this.modelValue,
            warning: this.warning,
            ...this.controlProps,
          },
          on: {
            change: this.onValueChange,
            clear: this.onClear,
          },
        },
        this.renderSubSections(h),
      );
    },
  };
}
